/**
 * 출장 현장 기상 정보 조회 훅
 * 경로 : 사내용 상황판 > 출장 현장 기상 정보(094), 출장 현황(091)
 * 동일한 queryKey를 사용하므로 두 위젯이 함께 배치되어도 API는 한 번만 호출된다.
 * queryKey에 cCd를 포함하여 본사/회사 전환 시 이전 회사의 캐시가 노출되지 않도록 한다.
 */

import { useQuery } from '@tanstack/react-query';
import { v4 } from 'uuid';
import { apiGet } from '../services/_common';

export const TRAVEL_WEATHER_QUERY_KEY = '/weather/travel/board_dashboard';

export const TRAVEL_WEATHER_COLORS: string[] = ['red', 'blue', 'green'];

export const getTravelWeather = async (cCd: string) => {
  try {
    const req = { cCd };
    const res = await apiGet({ path: '/weather/travel/board', req });
    const { data } = res.data;

    const newMap = (data ?? []).filter((el: any) => el.completeYn !== 'Y').map((el: any) => ({ ...el, id: v4() }));

    const chunkedArray = newMap.reduce((acc: any, item: any, index: number) => {
      const chunkIndex = Math.floor(index / 4);
      if (!acc[chunkIndex]) {
        acc[chunkIndex] = [];
      }

      const colorIdx = index % TRAVEL_WEATHER_COLORS.length;
      acc[chunkIndex].push({ ...item, color: TRAVEL_WEATHER_COLORS[colorIdx], colorIdx });
      return acc; // [{}, {}, ...] => [[{}, {}, ...], [{}, {}, ...], ...] 포멧으로 반환, 10초마다 4개씩 보여주기 위한 세팅
    }, []);

    return { travelArr: chunkedArray, oriArr: newMap };
  } catch (error) {
    console.log('error : ', error);
    throw new Error('ERROR: 출장 현장 정보를 가져오는데 실패했습니다.');
  }
};

interface IParams {
  cCd: string;
  refetchInterval?: number; // ms
  enabled?: boolean;
  onError?: (err: unknown) => void;
}

const useTravelWeather = ({ cCd, refetchInterval, enabled = true, onError }: IParams) =>
  useQuery([TRAVEL_WEATHER_QUERY_KEY, cCd], () => getTravelWeather(cCd), {
    enabled: enabled && !!cCd,
    ...(refetchInterval !== undefined && { refetchInterval }),
    refetchIntervalInBackground: true, // 포커싱 안되어 있어도 refetchInterval 기능 수행
    onError,
  });

export default useTravelWeather;
